import PropTypes from 'prop-types';

import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

import CommunityHeaderContainer from '../Header/CommunityHeaderContainer';
import CommunityMembersContainer from '../Members/CommunityMembersContainer';
import CommunityPostsListContainer from '../Post/CommunityPostsListContainer';

import ModalHandlerComponent from '../../Modal/ModalHandlerComponent';
import JoinCommunityComponent from '../components/JoinCommunityComponent';

import ErrorBoundary from '../../Main/ErrorBoundary';
import { CUSTOM } from '../../Modal/modalTypes';

const StyledContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: '2rem',
  marginTop: '2rem',
  [theme.breakpoints.down('sm')]: {
    flexWrap: 'wrap',
    marginTop: '1rem',
    gap: '1rem',
  },
}));

const StyledPostListContainer = styled(Box)(({ theme }) => ({
  width: '60%',
  [theme.breakpoints.down('sm')]: {
    width: '100%',
    order: 2,
  },
}));

const StyledMembersContainer = styled(Box)(({ theme }) => ({
  minWidth: '18rem',
  [theme.breakpoints.up('xl')]: {
    width: '30%',
  },
  [theme.breakpoints.up('lg')]: {
    width: '35%',
  },
  [theme.breakpoints.down('sm')]: {
    width: '100%',
    order: 1,
  },
}));

const CommunityComponent = (props) => {
  const {
    community,
    onCommunityChange,
    communityOptions,
    search,
    setSearch,
    communityType,
    setCommunityType,
    isShowJoinCommunity,
    setIsShowJoinCommunity,
    onCommunityOptIn,
  } = props;

  return (
    <>
      <CommunityHeaderContainer
        community={community}
        onCommunityChange={onCommunityChange}
        communityOptions={communityOptions}
        search={search}
        setSearch={setSearch}
        communityType={communityType}
      />

      <StyledContainer>
        <StyledPostListContainer>
          <ErrorBoundary>
            <CommunityPostsListContainer
              communityId={community?.value}
              search={search}
              communityType={communityType}
              setCommunityType={setCommunityType}
            />
          </ErrorBoundary>
        </StyledPostListContainer>
        <StyledMembersContainer>
          <ErrorBoundary>
            <CommunityMembersContainer communityId={community?.value} />
          </ErrorBoundary>
        </StyledMembersContainer>
      </StyledContainer>
      {isShowJoinCommunity && (
        <ModalHandlerComponent
          modal={{
            modalType: CUSTOM,
            modalProps: {},
          }}
          onModalClose={() => setIsShowJoinCommunity(false)}
        >
          <JoinCommunityComponent
            onJoinCommunity={onCommunityOptIn}
            onCancel={() => setIsShowJoinCommunity(false)}
          />
        </ModalHandlerComponent>
      )}
    </>
  );
};

CommunityComponent.propTypes = {
  community: PropTypes.instanceOf(Object).isRequired,
  onCommunityChange: PropTypes.func.isRequired,
  communityOptions: PropTypes.instanceOf(Array).isRequired,
  setSearch: PropTypes.func.isRequired,
  communityType: PropTypes.string.isRequired,
  setCommunityType: PropTypes.func.isRequired,
  isShowJoinCommunity: PropTypes.bool.isRequired,
  setIsShowJoinCommunity: PropTypes.func.isRequired,
  onCommunityOptIn: PropTypes.func.isRequired,
  search: PropTypes.string,
};

export default CommunityComponent;
